import React from '../../_snowpack/pkg/react.js';
import styled from '../../_snowpack/pkg/styled-components.js';
const defaultSize = '20px';

const setWidth = ({
  size,
  width
}) => width || size || defaultSize;

const setHeight = ({
  size,
  height
}) => height || size || defaultSize;

const SVG = styled.svg.withConfig({
  displayName: "backArrow1__SVG",
  componentId: "sc-1w4631e-0"
})(["width:", ";height:", ";", ";", ";", ";polygon{fill:", ";}"], setWidth, setHeight, p => p.left && 'transform: rotate(-180deg)', p => p.up && 'transform: rotate(-90deg)', p => p.down && 'transform: rotate(90deg)', p => p.fill || 'currentColor');
export default (({
  fill,
  width
}) => /*#__PURE__*/React.createElement(SVG, {
  "enable-background": "new 0 0 31.494 31.494",
  version: "1.1",
  viewBox: "0 0 31.494 31.494",
  fill: fill,
  width: width
}, /*#__PURE__*/React.createElement("path", {
  d: "m10.273 5.009c0.444-0.444 1.143-0.444 1.587 0 0.429 0.429 0.429 1.143 0 1.571l-8.047 8.047h26.554c0.619 0 1.127 0.492 1.127 1.111s-0.508 1.127-1.127 1.127h-26.554l8.047 8.032c0.429 0.444 0.429 1.159 0 1.587-0.444 0.444-1.143 0.444-1.587 0l-9.952-9.952c-0.429-0.429-0.429-1.143 0-1.571l9.952-9.952z"
})));